module.exports = __webpack_public_path__ + "img/C1.f1479687.jpg";